<template>
    <div id="optimizeEnterprise">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">企业资源与效率优化</div>
                    <div class="contentVal">
                        <span>针对企业现有资源</span>
                        <span>进行全方位的分析与最优化配置，让企业更高效、稳健地发展</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即咨询</button>
                </div>
            </div>
        </div>
        <!--相关产品-->
        <div class="relevantProduct">
            <div class="relevantProductTitle">相关产品</div>
            <!--产品列表-->
            <div class="relevantProductListWrap">
                <div class="relevantProductList" @click="toPage('/znkqdcSystem')" style="margin-right: 138px;">
                    <img src="../../assets/img/bigIcon/智能客群洞察系统.png"/>
                    <span>客群洞察系统</span>
                </div>
                <div class="relevantProductList" @click="toPage('/factorServices')" style="margin-right: 137px;">
                    <img src="../../assets/img/bigIcon/因子服务.png"/>
                    <span>因子服务</span>
                </div>
                <div class="relevantProductList" @click="toPage('/modelFactory')" style="margin-right: 143px;">
                    <img src="../../assets/img/bigIcon/模型工厂.png"/>
                    <span>模型工厂</span>
                </div>
                <div class="relevantProductList" @click="toPage('/smartLabel')" style="margin-right: 132px;">
                    <img src="../../assets/img/bigIcon/智能标签.png"/>
                    <span>智能标签</span>
                </div>
                <div class="relevantProductList" @click="toPage('/znyxSystem')">
                    <img src="../../assets/img/bigIcon/智能营销系统.png"/>
                    <span>智能营销系统</span>
                </div>
            </div>
        </div>
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "optimizeEnterprise",
        data() {
            return {
                showAlertFlag: false
            }
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #optimizeEnterprise {
        .bannerWrap {
            background: url("../../assets/img/bigDataOperating/企业资源与效率bg.png") no-repeat center;
            background-color: #00051D;
        }

        .relevantProduct {
            width: 934px;
        }
    }
</style>